import React from 'react';
import './categories.css'

const Category = (props) => {


    return (
            <div className="cat-tab">{props.category}</div>
    );

}
export default Category;